'use client';

import { handleError } from './handle-error';

/* eslint-disable @typescript-eslint/no-unsafe-argument */

export const storage = {
  set: (key: string, value: any) => {
    if (typeof window === 'undefined') return;

    try {
      if (!value) localStorage.removeItem(key);

      if (typeof value === 'object') {
        localStorage.setItem(key, JSON.stringify(value));

        return;
      }

      localStorage.setItem(key, value);
    } catch (error) {
      handleError(error);
    }
  },
  get: <T>(key: string) => {
    if (typeof window === 'undefined') return null;

    const item = localStorage.getItem(key);

    if (!item) return null;

    try {
      return JSON.parse(item) as T;
    } catch (e) {
      if (typeof item === 'string') {
        return item as T;
      }

      handleError(e);
    }
  },
  remove: (key: string) => {
    if (typeof window === 'undefined') return;

    try {
      localStorage.removeItem(key);
    } catch (error) {
      handleError(error);
    }
  },
  clear: () => {
    if (typeof window === 'undefined') return;

    try {
      localStorage.clear();
    } catch (error) {
      handleError(error);
    }
  },
  clearExcept(...keysToKeep: string[]): void {
    const preserved = keysToKeep.reduce<Record<string, string | null>>(
      (acc, key) => {
        acc[key] = localStorage.getItem(key);

        return acc;
      },
      {}
    );

    localStorage.clear();

    Object.entries(preserved).forEach(([key, value]) => {
      if (value !== null) {
        localStorage.setItem(key, value);
      }
    });
  },
};
